module.exports = __webpack_public_path__ + "static/media/sports_23.3d1a9d0a.jpg";